module.exports = __webpack_public_path__ + "img/qiye_logo.a69f8af6.png";